// src/components/zones/ThalwegTrench/TrenchCreatures.jsx
import React from 'react';
import ElectricEel            from './ElectricEel.jsx';
import SwimmingPiraibaCatfish from './PiraibaCatfish.jsx';
import SwimmingBotoDolphin    from './BotoDolphin.jsx';

export default function TrenchCreatures({
  zone,
  theme,
  onCreatureClick,
  highlightVersion,
}) {
  const isHighlighted = (versionNumber) =>
    highlightVersion != null && String(versionNumber) === String(highlightVersion);

  const showEel     = process.env.REACT_APP_SHOW_ELECTRIC_EEL     === 'true';
  const showPiraiba = process.env.REACT_APP_SHOW_PIRAIBA_CATFISH === 'true';
  const showDolphin = process.env.REACT_APP_SHOW_BOTO_DOLPHIN    === 'true';

  const v0 = zone?.versions?.[0];
  const v1 = zone?.versions?.[1];
  const v2 = zone?.versions?.[2];

  const handleClick = (v, name) => {
    if (onCreatureClick) onCreatureClick(v);
    else console.warn(`[TrenchCreatures] onCreatureClick not provided; clicked ${name}`, v);
  };

  return (
    <section className="relative w-full h-64 overflow-visible">
      {/* ─── Electric Eel (topmost) ─── */}
      {showEel && v2 && (
        <div
          role="button"
          aria-label="Electric eel"
          tabIndex={0}
          onClick={() => handleClick(v2, 'ElectricEel')}
          onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleClick(v2, 'ElectricEel')}
          style={{
            position: 'absolute',
            left: '10%',
            top: '88%',
            transform: 'translate(-50%, -50%)',
            cursor: 'pointer',
            zIndex: 30, // ensure eel sits above other swimmers
            outline: 'none',
          }}
        >
          <ElectricEel
            theme={theme}
            width={100}
            highlight={isHighlighted(v2.versionNumber)}
          />
        </div>
      )}

{/* ─── Piraíba Catfish ─── */}
{showPiraiba && v1 && (
  <div style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '90px', zIndex: 20 }}>
    <SwimmingPiraibaCatfish
      width={100}
      swimDuration="50s"
      minTop={90}
      maxTop={99}
      highlight={isHighlighted(v1.versionNumber)}
      onClick={() => handleClick(v1, 'PiraibaCatfish')}
    />
  </div>
)}

{/* ─── Boto Dolphin ─── */}
{showDolphin && v0 && (
  <div style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '0px', zIndex: 30 }}>
    <SwimmingBotoDolphin
      width={100}
      swimDuration="30s"   // make sure it's swimDuration, not "duration"
      minTop={80}
      maxTop={100}
      highlight={isHighlighted(v0.versionNumber)}
      onClick={() => handleClick(v0, 'BotoDolphin')}
    />
  </div>
)}

    </section>
  );
}
